import React from "react";
import "./HistoryDetailModal.css";

// 1. Cấu hình Từ điển (Mapping)
// Tại đây bạn định nghĩa: Key này tên tiếng Việt là gì? Format dữ liệu ra sao?
const FIELD_MAPPING = {
    // --- Thông tin chung ---
    id: { label: "ID", type: "text" },
    role: { label: "Vai trò", type: "role" },
    email: { label: "Email", type: "text" },
    username: { label: "Tên đăng nhập", type: "text" },
    full_name: { label: "Họ và tên", type: "text" },
    status: { label: "Trạng thái", type: "status" },
    created_at: { label: "Ngày tạo", type: "datetime" },
    updated_at: { label: "Ngày cập nhật", type: "datetime" },
    effective_date: { label: "Ngày hiệu lực", type: "date" },
    
    // --- Thông tin Agent/Hạn mức ---
    agent_id: { label: "ID Đại lý", type: "text" },
    agent_code: { label: "Mã đại lý", type: "text" },
    cif_number: { label: "Số CIF", type: "text" },
    account_number: { label: "Số tài khoản", type: "text" },
    daily_limit: { label: "Hạn mức ngày", type: "currency" },
    monthly_limit: { label: "Hạn mức tháng", type: "currency" },
    daily_deposit_limit: { label: "Hạn mức nộp/ngày", type: "currency" },
    daily_withdraw_limit: { label: "Hạn mức rút/ngày", type: "currency" },
};

export default function HistoryDetailModal({ isOpen, onClose, detail }) {
    if (!isOpen || !detail) return null;

    const stop = (e) => e.stopPropagation();

    // 2. Các hàm Format dữ liệu
    const formatCurrency = (val) => {
        if (!val) return "0 VNĐ";
        return new Intl.NumberFormat("vi-VN").format(val) + " VNĐ";
    };

    const formatDate = (val, time = false) => {
        if (!val) return "-";
        const date = new Date(val);
        if (isNaN(date.getTime())) return val; // Nếu không phải ngày hợp lệ thì trả về nguyên gốc
        
        const options = {
            year: 'numeric', month: '2-digit', day: '2-digit',
            ...(time && { hour: '2-digit', minute: '2-digit', second: '2-digit' })
        };
        return new Intl.DateTimeFormat('vi-VN', options).format(date);
    };

    const translateStatus = (val) => {
        const map = {
            ACTIVE: "Hoạt động",
            LOCKED: "Đã khóa",
            INACTIVE: "Ngừng hoạt động",
            SUPERVISOR: "Quản lý",
            STAFF: "Nhân viên",
            // Thêm các status khác nếu có
        };
        return map[val] || val;
    };

    // 3. Hàm render thông minh dựa trên Mapping
    const renderContent = (data) => {
        if (data === null || data === undefined) return "-";
        
        // Xử lý nếu data là JSON string
        let parsedData = data;
        if (typeof data === 'string') {
            try {
                const parsed = JSON.parse(data);
                if (typeof parsed === 'object' && parsed !== null) {
                    parsedData = parsed;
                }
            } catch (e) {
                // Không phải JSON, giữ nguyên string
            }
        }

        // Nếu là Object thì lặp qua từng key để hiển thị đẹp
        if (typeof parsedData === 'object' && parsedData !== null) {
            const entries = Object.entries(parsedData);
            if (entries.length === 0) return "-";

            return (
                <div className="hd-list">
                    {entries.map(([key, value]) => {
                        // Lấy cấu hình từ mapping, nếu không có thì dùng mặc định
                        const config = FIELD_MAPPING[key] || { label: key, type: "text" };
                        
                        let displayValue = value;

                        // Format giá trị dựa trên type
                        if (config.type === "currency") displayValue = formatCurrency(value);
                        else if (config.type === "datetime") displayValue = formatDate(value, true);
                        else if (config.type === "date") displayValue = formatDate(value, false);
                        else if (config.type === "status" || config.type === "role") displayValue = translateStatus(value);
                        else displayValue = String(value);

                        return (
                            <div key={key} className="hd-item">
                                <span className="hd-label">{config.label}:</span>
                                <span className={`hd-value ${key === 'status' ? 'hd-highlight' : ''}`}>
                                    {displayValue}
                                </span>
                            </div>
                        );
                    })}
                </div>
            );
        }

        return String(parsedData);
    };

    return (
        <div className="history-detail-overlay" onClick={onClose}>
            <div className="history-detail-modal" onClick={stop}>
                <div className="history-detail-header">
                    <h3>Chi tiết thay đổi</h3>
                    <span className="hd-close-icon" onClick={onClose}>✕</span>
                </div>

                <div className="history-detail-body">
                    <table className="history-detail-table">
                        <thead>
                            <tr>
                                <th style={{ width: '20%' }}>Loại thao tác</th>
                                <th style={{ width: '40%' }}>Thông tin cũ</th>
                                <th style={{ width: '40%' }}>Thông tin mới</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td style={{ fontWeight: 600, color: '#2c3e50' }}>
                                    {detail.fieldName}
                                </td>
                                <td>{renderContent(detail.oldValue)}</td>
                                <td>{renderContent(detail.newValue)}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                
            </div>
        </div>
    );
}